/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/directives/greetingdirective.html';
        var GreetingDirectiveController = /** @class */ (function (_super) {
            __extends(GreetingDirectiveController, _super);
            function GreetingDirectiveController($scope, appConfiguration) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.appConfiguration = appConfiguration;
                _this.initializeGreetingDirective();
                return _this;
            }
            GreetingDirectiveController.getDirective = function () {
                return {
                    controller: GreetingDirectiveController,
                    restrict: 'E',
                    scope: {
                        signup: '='
                    },
                    templateUrl: TemplateUrl
                };
            };
            GreetingDirectiveController.prototype.initializeGreetingDirective = function () {
                this.setGreeting();
            };
            GreetingDirectiveController.prototype.setGreeting = function () {
                var background = 'Login';
                var greeting = 'Good ';
                var morning = 'Morning';
                var afternoon = 'Afternoon';
                var evening = 'Evening';
                var hours = (new Date()).getHours();
                switch (true) {
                    case (hours < 12):
                        background += morning;
                        greeting += morning;
                        break;
                    case (hours < 17):
                        background += afternoon;
                        greeting += afternoon;
                        break;
                    case (hours < 20):
                        background += 'Early' + evening;
                        greeting += evening;
                        break;
                    default:
                        background += 'Late' + evening;
                        greeting += evening;
                        break;
                }
                angular.element('.greeting-holder').backstretch([this.appConfiguration.baseUrl + 'Content/Images/' + background + '.jpg']);
                this.$scope.greeting = this.$scope.signup ? 'Create an account' : greeting;
            };
            GreetingDirectiveController.$inject = [
                names.angular.Scope,
                names.zbuyer.AppConfiguration
            ];
            return GreetingDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.Greeting, GreetingDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/directives/hamburgermenudirective.html';
        var HamburgerMenuDirectiveController = /** @class */ (function (_super) {
            __extends(HamburgerMenuDirectiveController, _super);
            function HamburgerMenuDirectiveController($scope, $window, authenticationService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$window = $window;
                _this.authenticationService = authenticationService;
                _this.initializeViewModel();
                return _this;
            }
            HamburgerMenuDirectiveController.getDirective = function () {
                return {
                    controller: HamburgerMenuDirectiveController,
                    restrict: 'E',
                    scope: {
                        canProspect: '=',
                        canPreview: '=',
                        showMoreMenuCallback: '&onShowMore',
                    },
                    templateUrl: TemplateUrl
                };
            };
            HamburgerMenuDirectiveController.prototype.checkLogin = function () {
                var authHeader = this.authenticationService.getAuthenticationHeader();
                if (authHeader !== '') {
                    this.$scope.viewModel.loggedIntoAccount = true;
                    this.$scope.viewModel.loginButtonText = 'Log Out';
                }
                else {
                    this.$scope.viewModel.loggedIntoAccount = false;
                    this.$scope.viewModel.loginButtonText = 'Log In';
                }
            };
            HamburgerMenuDirectiveController.prototype.initializeViewModel = function () {
                this.$scope.viewModel = {};
                this.checkLogin();
            };
            HamburgerMenuDirectiveController.prototype.logOut = function () {
                this.authenticationService.logout();
            };
            HamburgerMenuDirectiveController.prototype.logIn = function () {
                this.$window.location.href = 'account/login';
            };
            HamburgerMenuDirectiveController.$inject = [
                names.angular.Scope,
                names.angular.Window,
                names.zbuyer.services.AuthenticationService
            ];
            return HamburgerMenuDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.HamburgerMenu, HamburgerMenuDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var EmailRegExp = /^([\w-+\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,11}|[0-9]{1,3})(\]?)$/;
        var LoginController = /** @class */ (function (_super) {
            __extends(LoginController, _super);
            function LoginController($scope, $cookies, $location, $timeout, $window, appConfiguration, accountService, appSettingsService, authenticationService, notificationService, spinWaitService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$cookies = $cookies;
                _this.$location = $location;
                _this.$timeout = $timeout;
                _this.$window = $window;
                _this.appConfiguration = appConfiguration;
                _this.accountService = accountService;
                _this.appSettingsService = appSettingsService;
                _this.authenticationService = authenticationService;
                _this.notificationService = notificationService;
                _this.spinWaitService = spinWaitService;
                _this.$scope.emailRegExp = EmailRegExp;
                _this.loginKey = _this.$location.search()[names.zbuyer.queryparameters.LoginKey];
                if (_this.loginKey) {
                    _this.loginWithKey();
                }
                else {
                    _this.authenticationService.getInitialAuthPromise().then(function (alreadyAuthenticated) {
                        if (alreadyAuthenticated) {
                            // Already authorized: shouldn't be here
                            _this.redirectOnAuthenticated();
                        }
                        else {
                            _this.initializeLoginController();
                        }
                    });
                }
                return _this;
            }
            LoginController.prototype.initializeLoginController = function () {
                var _this = this;
                var result = this.$location.search()[names.zbuyer.queryparameters.Result];
                if (result == names.zbuyer.loginreasons.Unauthorized) {
                    this.notificationService.info(zbuyer.messages.LoginRequired);
                }
                zbuyer.analytics.FacebookPixel.track(zbuyer.analytics.FacebookPixel.LoginPixelID, 'Login');
                var viewModel = this.$scope.viewModel = {};
                viewModel.username = this.$location.search()[names.zbuyer.queryparameters.Email];
                if (viewModel.username && viewModel.username.match(EmailRegExp)) {
                    this.accountService.matchAccountEmail(viewModel.username).then(function (accountExists) {
                        viewModel.emailConfirmed = accountExists;
                        if (viewModel.emailConfirmed) {
                            _this.$timeout(function () {
                                angular.element('#password').focus();
                            });
                        }
                    });
                }
                this.appSettingsService.getAppSettings().then(function (settings) {
                    _this.$scope.viewModel.appSettings = settings;
                }).catch(function (err) {
                    console.debug(err);
                    _this.notificationService.error(zbuyer.messages.AppSettingsError, zbuyer.messages.ApplicationTitle);
                });
            };
            LoginController.prototype.continue = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                if (!viewModel.username) {
                    // If the viewmodel does not contain a username, we should ensure that
                    // the browser has not supplied them automatically and failed to update Angular
                    var domUsername = $('[name="username"]').val().toString();
                    viewModel.username = domUsername;
                }
                if (!viewModel.username) {
                    return;
                }
                if (!viewModel.username || this.$scope.loginSignupForm.$invalid) {
                    this.$scope.validate = true;
                    return;
                }
                this.$scope.validate = false;
                if (!viewModel.emailConfirmed) {
                    this.accountService.matchAccountEmail(viewModel.username).then(function (accountExists) {
                        if (accountExists) {
                            viewModel.emailConfirmed = true;
                            _this.$timeout(function () {
                                angular.element('#password').focus();
                            });
                        }
                        else {
                            var signupUrl = new URL("signup".concat(_this.$window.location.search), _this.appConfiguration.baseUrl);
                            signupUrl.searchParams.set(names.zbuyer.queryparameters.Email, viewModel.username);
                            _this.$window.location.href = signupUrl.href;
                        }
                    });
                }
                else {
                    this.login();
                }
            };
            LoginController.prototype.emailChanged = function () {
                this.$scope.viewModel.emailConfirmed = null;
            };
            LoginController.prototype.login = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                if (!viewModel.username || !viewModel.password) {
                    // If the viewmodel does not contain a username and password, we should ensure that
                    // the browser has not supplied them automatically and failed to update Angular
                    var domUsername = $('[name="username"]').val().toString();
                    var domPassword = $('[name="password"]').val().toString();
                    if (!domUsername || !domPassword) {
                        this.notificationService.warning(zbuyer.messages.LoginCredentialsRequired, zbuyer.messages.LoginFailed);
                        return;
                    }
                    else {
                        viewModel.username = domUsername;
                        viewModel.password = domPassword;
                    }
                }
                this.spinWaitService.block(names.zbuyer.spinnermessages.LoginScreen);
                this.authenticationService.loginWithUserNameAndPassword(viewModel.username, viewModel.password).then(function (token) {
                    _this.redirectOnAuthenticated();
                }).catch(function (reason) { return _this.notificationService.error(reason.data.error_description, zbuyer.messages.LoginFailed); })
                    .finally(function () { return _this.spinWaitService.unblock(names.zbuyer.spinnermessages.LoginScreen); });
            };
            LoginController.prototype.loginWithKey = function () {
                var _this = this;
                var blockUiName = 'AutomaticLogin';
                this.spinWaitService.block(blockUiName);
                this.authenticationService.loginWithKey(this.loginKey).then(function (token) {
                    // Set up auto-navigate to account home as long as a return URL was not provided along with login key
                    if (!_this.$location.search().returnUrl && !_this.$location.search().ReturnUrl) {
                        _this.$cookies.put(names.zbuyer.cookies.NavigateTo, names.zbuyer.navigation.AccountHome);
                    }
                    _this.redirectOnAuthenticated();
                }).catch(function (reason) {
                    _this.notificationService.error(reason.data.error_description, zbuyer.messages.LoginFailed);
                    _this.spinWaitService.unblock(blockUiName);
                });
            };
            LoginController.prototype.redirectOnAuthenticated = function () {
                var url = new URL('landing', this.appConfiguration.baseUrl);
                var returnUrl = this.$location.search().returnUrl || this.$location.search().ReturnUrl;
                if (returnUrl) {
                    url.searchParams.set(names.zbuyer.queryparameters.ReturnUrl, returnUrl);
                }
                this.$window.location.replace(url.href);
            };
            LoginController.$inject = [
                names.angular.Scope,
                names.angular.Cookies,
                names.angular.Location,
                names.angular.Timeout,
                names.angular.Window,
                names.zbuyer.AppConfiguration,
                names.zbuyer.services.AccountService,
                names.zbuyer.services.AppSettingsService,
                names.zbuyer.services.AuthenticationService,
                names.zbuyer.services.NotificationService,
                names.zbuyer.services.SpinWaitService
            ];
            return LoginController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .controller(names.zbuyer.controllers.LoginController, LoginController);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var NavigationController = /** @class */ (function (_super) {
            __extends(NavigationController, _super);
            function NavigationController($scope, appSettingsService, notificationService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.appSettingsService = appSettingsService;
                _this.notificationService = notificationService;
                _this.$scope.viewModel = {};
                _this.setAppSettings();
                return _this;
            }
            NavigationController.prototype.setAppSettings = function () {
                var _this = this;
                this.appSettingsService.getAppSettings().then(function (settings) {
                    _this.$scope.viewModel.appSettings = settings;
                }).catch(function (err) {
                    console.debug(err);
                    _this.notificationService.error(zbuyer.messages.AppSettingsError, zbuyer.messages.ApplicationTitle);
                });
            };
            NavigationController.$inject = [
                names.angular.Scope,
                names.zbuyer.services.AppSettingsService,
                names.zbuyer.services.NotificationService
            ];
            return NavigationController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .controller(names.zbuyer.controllers.NavigationController, NavigationController);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/directives/sitefooterdirective.html';
        var SiteFooterDirectiveController = /** @class */ (function (_super) {
            __extends(SiteFooterDirectiveController, _super);
            function SiteFooterDirectiveController($scope, appSettingsService, notificationService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.appSettingsService = appSettingsService;
                _this.notificationService = notificationService;
                _this.initializeSiteFooterDirective();
                return _this;
            }
            SiteFooterDirectiveController.getDirective = function () {
                return {
                    controller: SiteFooterDirectiveController,
                    restrict: 'E',
                    scope: {
                        minimal: '='
                    },
                    templateUrl: TemplateUrl
                };
            };
            SiteFooterDirectiveController.prototype.initializeSiteFooterDirective = function () {
                var _this = this;
                this.$scope.viewModel = {};
                this.appSettingsService.getAppSettings().then(function (settings) {
                    _this.$scope.viewModel = settings;
                }).catch(function (err) {
                    console.debug(err);
                    _this.notificationService.error(zbuyer.messages.AppSettingsError, zbuyer.messages.ApplicationTitle);
                });
            };
            SiteFooterDirectiveController.prototype.getCopyrightYear = function () {
                var date = new Date();
                return date.getFullYear().toString();
            };
            SiteFooterDirectiveController.$inject = [
                names.angular.Scope,
                names.zbuyer.services.AppSettingsService,
                names.zbuyer.services.NotificationService
            ];
            return SiteFooterDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.SiteFooter, SiteFooterDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

//# sourceMappingURL=app-login.js.map
